export const energyConfig = {
  name: '能量管理',
  description: '科学评估和管理身体、情绪、心智、精神四大能量',
  icon: 'ThunderboltOutlined',
  bgColor: '#722ED1',
  iconColor: '#FFFFFF',
  
  // API端点
  apiEndpoints: {
    energyAssessments: '/energy',
    createAssessment: '/energy',
    updateAssessment: '/energy',
    deleteAssessment: '/energy',
    energyStats: '/energy/stats',
    energyHistory: '/energy/history',
    energyTrends: '/energy/trends'
  },

  // 能量类型定义
  energyTypes: [
    {
      key: 'physical',
      name: '身体能量',
      icon: '💪',
      color: '#52C41A',
      description: '身体机能和生理状态',
      maxScore: 100,
      factors: ['睡眠质量', '饮食营养', '运动锻炼', '身体状态']
    },
    {
      key: 'emotional',
      name: '情绪能量',
      icon: '😊',
      color: '#FAAD14',
      description: '情绪稳定性和心理健康',
      maxScore: 100,
      factors: ['情绪稳定', '压力管理', '社交活动', '兴趣爱好']
    },
    {
      key: 'mental',
      name: '心智能量',
      icon: '🧠',
      color: '#1890FF',
      description: '认知能力和思维效率',
      maxScore: 100,
      factors: ['专注力', '学习能力', '时间管理', '决策能力']
    },
    {
      key: 'spiritual',
      name: '精神能量',
      icon: '✨',
      color: '#722ED1',
      description: '价值观和人生意义',
      maxScore: 100,
      factors: ['价值观', '人生目标', '创造力', '内在动力']
    }
  ],

  // 身体能量问卷
  physicalEnergyQuestions: [
    {
      id: 'sleep_quality',
      question: '睡眠质量评估',
      description: '请评估你的睡眠质量',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '经常失眠，睡眠质量差' },
        { value: 2, label: '较差', score: 25, description: '偶尔失眠，睡眠不规律' },
        { value: 3, label: '一般', score: 40, description: '睡眠基本正常，但质量一般' },
        { value: 4, label: '良好', score: 60, description: '睡眠质量较好，基本规律' },
        { value: 5, label: '优秀', score: 80, description: '睡眠质量很好，深度睡眠充足' },
        { value: 6, label: '完美', score: 100, description: '睡眠质量极佳，精力充沛' }
      ],
      weight: 0.25
    },
    {
      id: 'sleep_duration',
      question: '平均睡眠时长',
      description: '你平均每天睡眠多长时间？',
      type: 'scale',
      options: [
        { value: 1, label: '<5小时', score: 10, description: '睡眠严重不足' },
        { value: 2, label: '5-6小时', score: 30, description: '睡眠不足' },
        { value: 3, label: '6-7小时', score: 50, description: '睡眠基本充足' },
        { value: 4, label: '7-8小时', score: 80, description: '睡眠充足' },
        { value: 5, label: '8-9小时', score: 90, description: '睡眠很充足' },
        { value: 6, label: '>9小时', score: 70, description: '睡眠过多' }
      ],
      weight: 0.20
    },
    {
      id: 'nutrition',
      question: '饮食营养状况',
      description: '请评估你的饮食营养状况',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '饮食不规律，营养不均衡' },
        { value: 2, label: '较差', score: 25, description: '偶尔不规律，营养摄入不足' },
        { value: 3, label: '一般', score: 40, description: '基本规律，营养基本均衡' },
        { value: 4, label: '良好', score: 60, description: '饮食规律，营养均衡' },
        { value: 5, label: '优秀', score: 80, description: '饮食很规律，营养丰富' },
        { value: 6, label: '完美', score: 100, description: '科学饮食，营养全面' }
      ],
      weight: 0.25
    },
    {
      id: 'exercise',
      question: '运动锻炼频率',
      description: '你每周进行多少次运动锻炼？',
      type: 'scale',
      options: [
        { value: 1, label: '从不运动', score: 10, description: '缺乏运动，身体机能下降' },
        { value: 2, label: '1-2次', score: 30, description: '运动频率较低' },
        { value: 3, label: '3-4次', score: 50, description: '运动频率适中' },
        { value: 4, label: '5-6次', score: 70, description: '运动频率较高' },
        { value: 5, label: '每天运动', score: 90, description: '运动频率很高' },
        { value: 6, label: '专业训练', score: 100, description: '专业运动训练' }
      ],
      weight: 0.20
    },
    {
      id: 'physical_condition',
      question: '身体状态评估',
      description: '请评估你当前的身体状态',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '经常感到疲劳，身体不适' },
        { value: 2, label: '较差', score: 25, description: '偶尔疲劳，身体状态一般' },
        { value: 3, label: '一般', score: 40, description: '身体状态基本正常' },
        { value: 4, label: '良好', score: 60, description: '身体状态较好，精力充沛' },
        { value: 5, label: '优秀', score: 80, description: '身体状态很好，充满活力' },
        { value: 6, label: '完美', score: 100, description: '身体状态极佳，能量充沛' }
      ],
      weight: 0.10
    }
  ],

  // 情绪能量问卷
  emotionalEnergyQuestions: [
    {
      id: 'stress_level',
      question: '压力水平评估',
      description: '请评估你当前的压力水平',
      type: 'scale',
      options: [
        { value: 1, label: '极高压力', score: 10, description: '压力极大，严重影响生活' },
        { value: 2, label: '高压力', score: 25, description: '压力较大，影响情绪' },
        { value: 3, label: '中等压力', score: 40, description: '压力适中，基本可控' },
        { value: 4, label: '低压力', score: 60, description: '压力较小，情绪稳定' },
        { value: 5, label: '很低压力', score: 80, description: '压力很小，情绪很好' },
        { value: 6, label: '无压力', score: 100, description: '几乎没有压力，心情愉悦' }
      ],
      weight: 0.25
    },
    {
      id: 'emotion_stability',
      question: '情绪稳定性',
      description: '请评估你的情绪稳定性',
      type: 'scale',
      options: [
        { value: 1, label: '很不稳定', score: 10, description: '情绪波动很大，难以控制' },
        { value: 2, label: '不稳定', score: 25, description: '情绪波动较大' },
        { value: 3, label: '一般', score: 40, description: '情绪基本稳定' },
        { value: 4, label: '稳定', score: 60, description: '情绪比较稳定' },
        { value: 5, label: '很稳定', score: 80, description: '情绪很稳定' },
        { value: 6, label: '极稳定', score: 100, description: '情绪极其稳定' }
      ],
      weight: 0.25
    },
    {
      id: 'social_activity',
      question: '社交活动频率',
      description: '你参与社交活动的频率如何？',
      type: 'scale',
      options: [
        { value: 1, label: '几乎不社交', score: 10, description: '很少参与社交活动' },
        { value: 2, label: '很少社交', score: 25, description: '偶尔参与社交活动' },
        { value: 3, label: '一般', score: 40, description: '社交活动频率适中' },
        { value: 4, label: '较多', score: 60, description: '经常参与社交活动' },
        { value: 5, label: '很多', score: 80, description: '社交活动很频繁' },
        { value: 6, label: '极多', score: 100, description: '社交活动极其频繁' }
      ],
      weight: 0.20
    },
    {
      id: 'hobbies',
      question: '兴趣爱好',
      description: '你有多少种兴趣爱好？',
      type: 'scale',
      options: [
        { value: 1, label: '无兴趣', score: 10, description: '没有特别的兴趣爱好' },
        { value: 2, label: '1-2种', score: 30, description: '有少量兴趣爱好' },
        { value: 3, label: '3-4种', score: 50, description: '有适中的兴趣爱好' },
        { value: 4, label: '5-6种', score: 70, description: '有较多的兴趣爱好' },
        { value: 5, label: '7-8种', score: 85, description: '有很多兴趣爱好' },
        { value: 6, label: '8种以上', score: 100, description: '有极其丰富的兴趣爱好' }
      ],
      weight: 0.15
    },
    {
      id: 'relaxation',
      question: '放松方法',
      description: '你有多少种有效的放松方法？',
      type: 'scale',
      options: [
        { value: 1, label: '无方法', score: 10, description: '没有有效的放松方法' },
        { value: 2, label: '1种', score: 30, description: '有1种放松方法' },
        { value: 3, label: '2-3种', score: 50, description: '有2-3种放松方法' },
        { value: 4, label: '4-5种', score: 70, description: '有4-5种放松方法' },
        { value: 5, label: '6-7种', score: 85, description: '有6-7种放松方法' },
        { value: 6, label: '8种以上', score: 100, description: '有8种以上放松方法' }
      ],
      weight: 0.15
    }
  ],

  // 心智能量问卷
  mentalEnergyQuestions: [
    {
      id: 'focus_ability',
      question: '专注力评估',
      description: '请评估你的专注力水平',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '很难集中注意力' },
        { value: 2, label: '较差', score: 25, description: '专注力较差' },
        { value: 3, label: '一般', score: 40, description: '专注力一般' },
        { value: 4, label: '良好', score: 60, description: '专注力较好' },
        { value: 5, label: '优秀', score: 80, description: '专注力很好' },
        { value: 6, label: '完美', score: 100, description: '专注力极佳' }
      ],
      weight: 0.25
    },
    {
      id: 'learning_ability',
      question: '学习能力',
      description: '请评估你的学习能力',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '学习能力很差' },
        { value: 2, label: '较差', score: 25, description: '学习能力较差' },
        { value: 3, label: '一般', score: 40, description: '学习能力一般' },
        { value: 4, label: '良好', score: 60, description: '学习能力较好' },
        { value: 5, label: '优秀', score: 80, description: '学习能力很好' },
        { value: 6, label: '完美', score: 100, description: '学习能力极佳' }
      ],
      weight: 0.25
    },
    {
      id: 'time_management',
      question: '时间管理能力',
      description: '请评估你的时间管理能力',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '时间管理能力很差' },
        { value: 2, label: '较差', score: 25, description: '时间管理能力较差' },
        { value: 3, label: '一般', score: 40, description: '时间管理能力一般' },
        { value: 4, label: '良好', score: 60, description: '时间管理能力较好' },
        { value: 5, label: '优秀', score: 80, description: '时间管理能力很好' },
        { value: 6, label: '完美', score: 100, description: '时间管理能力极佳' }
      ],
      weight: 0.25
    },
    {
      id: 'decision_making',
      question: '决策能力',
      description: '请评估你的决策能力',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '决策能力很差' },
        { value: 2, label: '较差', score: 25, description: '决策能力较差' },
        { value: 3, label: '一般', score: 40, description: '决策能力一般' },
        { value: 4, label: '良好', score: 60, description: '决策能力较好' },
        { value: 5, label: '优秀', score: 80, description: '决策能力很好' },
        { value: 6, label: '完美', score: 100, description: '决策能力极佳' }
      ],
      weight: 0.25
    }
  ],

  // 精神能量问卷
  spiritualEnergyQuestions: [
    {
      id: 'values_clarity',
      question: '价值观清晰度',
      description: '请评估你的价值观清晰度',
      type: 'scale',
      options: [
        { value: 1, label: '很模糊', score: 10, description: '价值观很模糊' },
        { value: 2, label: '模糊', score: 25, description: '价值观比较模糊' },
        { value: 3, label: '一般', score: 40, description: '价值观基本清晰' },
        { value: 4, label: '清晰', score: 60, description: '价值观比较清晰' },
        { value: 5, label: '很清晰', score: 80, description: '价值观很清晰' },
        { value: 6, label: '极清晰', score: 100, description: '价值观极其清晰' }
      ],
      weight: 0.25
    },
    {
      id: 'life_purpose',
      question: '人生目标明确度',
      description: '请评估你的人生目标明确度',
      type: 'scale',
      options: [
        { value: 1, label: '很模糊', score: 10, description: '人生目标很模糊' },
        { value: 2, label: '模糊', score: 25, description: '人生目标比较模糊' },
        { value: 3, label: '一般', score: 40, description: '人生目标基本明确' },
        { value: 4, label: '明确', score: 60, description: '人生目标比较明确' },
        { value: 5, label: '很明确', score: 80, description: '人生目标很明确' },
        { value: 6, label: '极明确', score: 100, description: '人生目标极其明确' }
      ],
      weight: 0.25
    },
    {
      id: 'creativity',
      question: '创造力水平',
      description: '请评估你的创造力水平',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '创造力很差' },
        { value: 2, label: '较差', score: 25, description: '创造力较差' },
        { value: 3, label: '一般', score: 40, description: '创造力一般' },
        { value: 4, label: '良好', score: 60, description: '创造力较好' },
        { value: 5, label: '优秀', score: 80, description: '创造力很好' },
        { value: 6, label: '完美', score: 100, description: '创造力极佳' }
      ],
      weight: 0.25
    },
    {
      id: 'motivation',
      question: '内在动力',
      description: '请评估你的内在动力水平',
      type: 'scale',
      options: [
        { value: 1, label: '很差', score: 10, description: '内在动力很差' },
        { value: 2, label: '较差', score: 25, description: '内在动力较差' },
        { value: 3, label: '一般', score: 40, description: '内在动力一般' },
        { value: 4, label: '良好', score: 60, description: '内在动力较好' },
        { value: 5, label: '优秀', score: 80, description: '内在动力很好' },
        { value: 6, label: '完美', score: 100, description: '内在动力极佳' }
      ],
      weight: 0.25
    }
  ],

  // 能量管理TIPS
  energyManagementTips: {
    title: '能量管理四大原则',
    description: '科学管理身体、情绪、心智、精神四大能量',
    principles: [
      {
        title: '身体能量',
        description: '通过良好的睡眠、饮食、运动来维持身体机能',
        icon: '💪',
        tips: [
          '保证7-8小时优质睡眠',
          '均衡营养，定时定量',
          '每周运动3-5次',
          '定期体检，关注健康'
        ]
      },
      {
        title: '情绪能量',
        description: '通过压力管理、社交活动、兴趣爱好来维持情绪稳定',
        icon: '😊',
        tips: [
          '学会压力管理技巧',
          '保持积极社交关系',
          '培养多种兴趣爱好',
          '练习放松和冥想'
        ]
      },
      {
        title: '心智能量',
        description: '通过专注训练、学习提升、时间管理来增强认知能力',
        icon: '🧠',
        tips: [
          '练习专注力训练',
          '持续学习新知识',
          '提高时间管理效率',
          '培养决策能力'
        ]
      },
      {
        title: '精神能量',
        description: '通过价值观明确、目标设定、创造力培养来提升精神境界',
        icon: '✨',
        tips: [
          '明确个人价值观',
          '设定清晰人生目标',
          '培养创造力和想象力',
          '保持内在动力和激情'
        ]
      }
    ]
  },

  // 能量评估建议
  energyAssessmentAdvice: {
    title: '能量评估建议',
    description: '根据评估结果提供个性化建议',
    adviceLevels: [
      {
        level: 'low',
        range: [0, 40],
        title: '能量不足',
        description: '需要重点关注和改善',
        suggestions: [
          '制定详细的改善计划',
          '寻求专业指导',
          '建立良好的生活习惯',
          '定期重新评估'
        ]
      },
      {
        level: 'medium',
        range: [41, 70],
        title: '能量一般',
        description: '有提升空间，需要持续改善',
        suggestions: [
          '识别薄弱环节',
          '制定针对性改善措施',
          '保持现有良好习惯',
          '定期评估进展'
        ]
      },
      {
        level: 'high',
        range: [71, 100],
        title: '能量充沛',
        description: '状态良好，继续保持',
        suggestions: [
          '维持现有良好状态',
          '分享成功经验',
          '帮助他人提升',
          '定期评估保持'
        ]
      }
    ]
  }
};
